import { memo, useCallback } from "react";
import { Modal, Button } from "antd";
import IntlMessages from "../Message/IntlMessages";
import { formatNumber } from "utils/math";
import { confirmPayment, subscriptionDetailChange } from "redux/reducers/subscription";
import { useDispatch } from "react-redux";

function parseCbsRemainMessage(message) {
  if (!message) return null;

  const parts = message.split(",").map((part) => part.trim());
  return {
    remainingBaht: parts[0],
    remainingUnit: parts[1],
    whtAmount: parts[2],
  };
}

function parseFiniteAmount(value) {
  if (value === undefined || value === null || value === "") return null;

  const amount = Number(value);
  return Number.isFinite(amount) ? amount : null;
}

function hasWhtAmount(whtAmount) {
  return whtAmount !== undefined && whtAmount !== null && whtAmount !== "";
}

function getDisplayTotalAmount(remainingBaht, whtAmount) {
  const bahtAmount = parseFiniteAmount(remainingBaht);
  if (bahtAmount == null) return null;

  const whtTaxAmount = parseFiniteAmount(whtAmount);
  return whtTaxAmount == null ? bahtAmount : bahtAmount + whtTaxAmount;
}

const AcceptUnitAvaliable = ({ close, actions, state, ...modalProps }) => {
  const dispatch = useDispatch();

  const { message: message, params = [], extraMessages, isHttpError, payload } = state ?? {};

  function _onAccept() {
    confirmUnitAllowValiable();
  }

  // const onSubmit = useCallback(async () => {
  // const { email } = await form.validateFields(['email'])
  // sendEmail(email)
  // }, [form, sendEmail])

  // const onFinish = useCallback(({ otp }) => {
  // const payload = {
  //     data: { otp },
  //     onComplete: () => nextPage(),
  //     backToEditUnit: () => backToEditUnit(),
  // };
  // dispatch(confirmPayment(payload));
  // }, [dispatch, nextPage, backToEditUnit])

  const confirmUnitAllowValiable = useCallback(
    ({ message, payload }) => {
      const parsedMessage = parseCbsRemainMessage(message);

      if (parsedMessage && (parsedMessage.remainingBaht || parsedMessage.remainingUnit)) {
        const { remainingBaht, remainingUnit, whtAmount } = parsedMessage;
        const subscriptionUpdate = {
          baht: remainingBaht,
          unit: remainingUnit,
        };
        if (hasWhtAmount(whtAmount)) {
          subscriptionUpdate.whtAmount = whtAmount;
        }
        dispatch(subscriptionDetailChange(subscriptionUpdate));
      }
      dispatch(confirmPayment(payload));
      close();
    },
    [dispatch, close],
  );

  function _onCancel() {
    close();
    actions?.onCancel && actions.onCancel();
  }

  function renderMessage() {
    const parsedMessage = parseCbsRemainMessage(message);
    if (!parsedMessage) return null;

    const { remainingBaht, whtAmount } = parsedMessage;
    const totalAmount = getDisplayTotalAmount(remainingBaht, whtAmount);
    if (totalAmount == null) return null;

    return (
      <p className="text-center">
        <IntlMessages
          id="transaction.unit.not.enough"
          values={{
            amount: formatNumber(totalAmount, 2, { dontRound: true }),
          }}
        />
      </p>
    );
  }

  return (
    <Modal {...modalProps} maskClosable={false} onCancel={close}>
      {modalProps.visible && (
        <div className="mnc-modal-disclaimer">
          <div className="modal-mnc-head">
            <h5 className="m-0">
              <IntlMessages id="modal.disclaimer.header.subscription-problem" />
            </h5>
            <Button className="btn button-ktb-close" onClick={_onCancel}>
              <i className="feather-icon icon-x"></i>
            </Button>
          </div>
          <div
            className="modal-mnc-body"
            style={{
              whiteSpace: "pre-wrap",
              overflowX: "auto",
            }}
          >
            {renderMessage()}{" "}
          </div>
          <div className="modal-mnc-footer">
            <div className="row justify-content-center">
              <div className="col-6 ps-1 ps-md-2">
                <div className="d-grid">
                  <Button data-logout-btn className="btn button-ktb-line" onClick={_onCancel}>
                    <IntlMessages id="global.back" />
                  </Button>
                </div>
              </div>
              <div className="col-6 ps-1 ps-md-2">
                <div className="d-grid">
                  <Button
                    data-accept-btn
                    className="btn button-ktb-main"
                    onClick={() => confirmUnitAllowValiable(state)}
                  >
                    <IntlMessages id="global.ok" />
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}{" "}
    </Modal>
  );
};

export default memo(AcceptUnitAvaliable);
